export default "assets/images/icons/pause-f50d20ff.svg";